<template>
  <div>
    <div v-if="title" class="title-container">
      <prismic-rich-text :field="title" class="search-grid-title"></prismic-rich-text>
      <div v-if="buttonText && buttonPath" class="mx-2">
        <Button
          shape="outline"
          size="small"
          font-size="13"
          color="white"
          text="gray"
          hover="exp"
          :blank="buttonBlank"
          :to="buttonPath"
        >
          {{ buttonText }}
        </Button>
      </div>
    </div>
    <Grid :items="items" :hide-uncompleted-rows="true" @item-click="vectorClick">
      <template #default="slotProps">
        <NormalVectorOverlay :data="slotProps.data" />
      </template>
    </Grid>
  </div>
</template>

<script>
import Button from 'UI/Button';
import Grid from '@/components/Common/Grid';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

export default {
  components: {
    Button,
    Grid,
    NormalVectorOverlay
  },
  props: {
    slice: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      buttonBlank: '',
      buttonPath: '',
      buttonText: '',
      title: ''
    };
  },
  async fetch() {
    const { primary } = this.slice;

    this.buttonBlank = primary.button_blank;
    this.buttonPath = primary.button_path && primary.button_path[0]?.text;
    this.buttonText = primary.button_text && primary.button_text[0]?.text;
    this.title = primary?.title1[0]?.text ? primary.title1 : '';
  },
  methods: {
    async vectorClick({ item, shownListing }, e) {
      this.$emit('item-click', { item, shownListing }, e);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-grid-title {
  font-weight: 500;
  margin-top: 5px;
}
.title-container {
  display: flex;
  align-items: center;
  margin: 0 0 10px 5px;
}
</style>

<style lang="scss">
.search-grid-title {
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 1.25em;
  }
}
</style>
